import React, { useState } from 'react';
import AuthLayout from '../../components/layout/AuthLayout.jsx';
import useCurrentUser from '../../hooks/useCurrentUser.js';
import BaseButton from '../../components/form/BaseButton.jsx';
import { useGetRolesQuery, useGetRoleTypesQuery } from '../../api/roles.js';
import ThreeDotsLoader from '../../components/misc/ThreeDotsLoader.jsx';
import RolesListItem from '../../components/misc/users/RolesListItem.jsx';
import RoleAddEditForm from '../../components/misc/users/RoleAddEditForm.jsx';
import '../../resources/styles/sphere-bg.scss';
import { PERMISSION_ROLES } from '../../utils/constants.js';

const UserRoles = () => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [selectedRoleId, setSelectedRoleId] = useState(null);
    const { user, permissions: userPermissions } = useCurrentUser();
    const { data: roles, error: rolesError, isLoading: rolesLoading } = useGetRolesQuery();
    const { data: roleTypes, error: roleTypesError, isLoading: roleTypesLoading } = useGetRoleTypesQuery();

    const rolesList = roles?.response?.roles || [];
    const rolesTypesList = roleTypes?.response?.role_types || [];

    const handleAddRole = () => {
        setSelectedRoleId(null);
        setShowOverlay(true);
    };

    const handleEditRole = (roleId) => {
        setSelectedRoleId(roleId);
        setShowOverlay(true);
    };

    return (
        <AuthLayout title='User Roles' backRoute='/dashboard' mainClassNames='bg-no-repeat bg-bottom bg-sphere'>
            <div className='flex flex-col max-w-3xl w-full mx-auto mt-6'>
                <div className='px-8 mb-7'>
                    <div className='text-theme1-primary text-[45px] font-[300] leading-none'>Good Day,</div>
                    <div className='text-theme1-primary text-[35px] font-bold'>{user.name}</div>
                    <div className='text-theme1-primary text-[20px] mt-3'>Let's create some new roles!</div>
                    {!!userPermissions[PERMISSION_ROLES]?.create && (
                        <BaseButton
                            className='mt-8 btn-red-outline'
                            textValue='Create new role'
                            onClick={handleAddRole}
                        />
                    )}
                    <div className='text-theme1-title2 text-[22px] font-bold mt-8 mb-4'>Existing roles</div>
                    {rolesLoading ? (
                        <ThreeDotsLoader />
                    ) : rolesError ? (
                        <div className='text-theme1-primary text-base'>Error loading roles</div>
                    ) : rolesList.length > 0 ? (
                        rolesList.map((role) => (
                            <RolesListItem
                                key={role.id}
                                user={user}
                                role={role}
                                rolesTypesList={rolesTypesList}
                                onEditRole={handleEditRole}
                            />
                        ))
                    ) : (
                        <div className='text-theme1-primary text-base px-4'>No existing roles found</div>
                    )}
                </div>
            </div>

            <RoleAddEditForm
                key={selectedRoleId || 'new-role'}
                showOverlay={showOverlay}
                setShowOverlay={setShowOverlay}
                roleId={selectedRoleId}
                user={user}
                rolesTypesList={rolesTypesList}
                roleTypesLoading={roleTypesLoading}
            />
        </AuthLayout>
    );
};

export default UserRoles;
